import api from '../utils/baseUrl';

class FeedbackService {
    async sendFeedback(body: object) {
        try {
            const response = await api.post(`api/feedback`, body);
            return Array.isArray(response.data) ? response.data : [];
        } catch (error) {
            console.error('Error sending feedback:', error);
            return [];
        }
    }
}

export default new FeedbackService();